/* @flow */
import * as React from 'react';
import { Route } from 'react-router-dom';

type Props = {
  component: React.ComponentType<any>,
  props: Object,
};

export default function AppliedRoute<C: React.ComponentType<Props>>({
  component: Component,
  props: cProps,
  ...rest
}: Props): React.Element<C> {
  return <Route {...rest} render={(props) => <Component {...props} {...cProps} />} />;
}
